export enum ApplicantType {
    Company = 0,
    Person = 1
}

export const applicantType = {
  0: 'Juridinis asmuo ar jo atstovas',
  1: 'Fizinis asmuo vykdantis ūkinę komercinę veiklą'
};
